import { SHAPE_PREFIX_ID } from '@frontend/constants/templates-field-prefixes';
import { isInGroup } from '@frontend/utils';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { fabric } from 'fabric';
import { parseJsonData } from "@frontend/services/helpers";
import { getGroupNameByAddFieldId } from "@/common/preview/draw-smart-object";

const getScopePage = () => ShowPageScopeCollector.get(['canvas_data']);

const DEFAULT_THICKNESS = 5;

export function drawLine(params) {
  const {
    fields,
    canvas,
    id,
    group_fields,
    dimension,
    data
  } = params;

  canvas.getObjects().forEach(function (o) {
    if (o.id.includes(SHAPE_PREFIX_ID)) {
      canvas.remove(o);
    }
  });

  const { canvas_data } = getScopePage();

  canvas_data[id].lineCoords = [];
  let index = 0;

  fields.forEach(async (field) => {
    const options = JSON.parse(field.options);
    const groupName = getGroupNameByAddFieldId(
      String(field.id),
      canvas_data[id]
    );

    if (field.type === 'Line' && (!group_fields || isInGroup(group_fields, field.name))) {
      const w = parseInt(options['Width']);
      const h = parseInt(options['Height']);
      const x = parseInt(options['X']);
      const y = parseInt(options['Y']);
      const coords = data[`${field.element_id}_coords`]
        ? data[`${field.element_id}_coords`]
        : [x, y, (x + (w > h ? w : 0)), (y + (w < h ? h : 0)),];
      const visible = !options.Hidden;

      const optionsThickness = w > h ? h : (h > w ? w : DEFAULT_THICKNESS);
      const offsetX = parseInt(data[`${field.element_id}_offset_x`]);
      const offsetY = parseInt(data[`${field.element_id}_offset_y`]);

      const line = new fabric.Line(
        coords,
        {
          id: SHAPE_PREFIX_ID + index,
          fieldId: field.id,
          groupName: groupName,
          fieldType: field.type,
          element_id: field.element_id,
          order: parseInt(options['Order']),
          fill: options['Option1'] ? options['Option1'] : options['Font Color'],
          stroke: data[`${field.element_id}_stroke_color`]
            ? data[`${field.element_id}_stroke_color`]
            : options['Option1'] ? options['Option1'] : options['Font Color'],
          strokeWidth: data[`${field.element_id}_thickness`] ? +data[`${field.element_id}_thickness`] : optionsThickness,
          selectable: options['Moveable'] === 'Yes',
          evented: options['Moveable'] === 'Yes',
          visible,
          left: offsetX ? offsetX : x,
          top: offsetY ? offsetY : y,
          opacity: data[`${field.element_id}_opacity`] ? data[`${field.element_id}_opacity`] : 1,
          angle: parseInt(canvas_data[id]._data[`${field.element_id}_angle`] ?? options['Angle']),
          coords: coords,
          templateField: canvas_data[id].templateInstance.getFieldById(field.id)
        }
      );

      let group_x = 0;
      let group_y = 0;
      if (groupName && canvas_data[id].smartObjCoords[groupName]) {
        group_x = parseInt(canvas_data[id].smartObjCoords[groupName]['X']);
        group_y = parseInt(canvas_data[id].smartObjCoords[groupName]['Y']);
      }

      line.set({
        left: line.left + group_x - dimension[2] + dimension[4].x,
        top: line.top + group_y - dimension[3] + dimension[4].y
      });

      canvas.add(line);
      canvas_data[id].lineCoords.push({x: x, y: y,});

      processRelated(options, canvas, line, 0);
      index++;
    }
  });
}

const processRelated = async (
    options,
    canvas,
    line,
    retries
) => {
  var relatedFieldName = "";
  var margin = 5;
  var moveDownOnly = false;

  try {
    let parsedOption = parseJsonData(options['Option2'], null);

    if (parsedOption && parsedOption.field && parsedOption.field.trim() !== "") {
      relatedFieldName = parsedOption.field;
    }
    if (parsedOption && parsedOption.margin !== undefined) {
      margin = parsedOption.margin;
    }
    if (parsedOption && parsedOption.move_down_only !== undefined) {
      moveDownOnly = parsedOption.move_down_only;
    }
  } catch (e) {
    console.error("Invalid JSON string", e);
  }

  if (!relatedFieldName) {
    return;
  }

  var canvasObjects = canvas.getObjects();
  var relatedField = null;
  canvasObjects.forEach((obj) => {
    if (obj.templateField && obj.templateField.name === relatedFieldName) {
      relatedField = obj;
    } else if (obj.name && obj.name === relatedFieldName) {
      relatedField = obj;
    }
  });

  if (relatedField) {
    let topPosition = relatedField.top + relatedField.height + margin;
    if (moveDownOnly && topPosition < +options.Y) {
      topPosition = +options.Y;
    }
    // Move object
    line.set({top: topPosition});
  } else {
    // Retry logic
    await new Promise((r) => setTimeout(r, 1200));
    if (retries < 20) {
      await processRelated(options, canvas, line, retries);
    }
  }
}
